import { CREATE_BULK_LABEL_FAILURE, CREATE_BULK_LABEL_REQUEST, CREATE_BULK_LABEL_RESET, CREATE_BULK_LABEL_SUCCESS, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const sendBulkLabelDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_BULK_LABEL_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case CREATE_BULK_LABEL_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case CREATE_BULK_LABEL_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case CREATE_BULK_LABEL_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default sendBulkLabelDetailsReducer;
